export default __webpack_public_path__ + "static/webapp-684b218b63fab6e7f69f82a4f0d6471f.svg";